module.exports = __webpack_public_path__ + "static/media/tm.93283390.svg";